import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'about',
  `
    START_QUIZ
    SET_QUIZ_CARD_NAME
    FLIP_QUIZ_CARD
    NEXT_QUIZ_CARD
  `
);
